import { hot } from 'react-hot-loader';
import Seo from '../components/Seo';
import Footer from '../components/Footer';
import ScreenIpfs from '../screens/ScreenIpfs';



function IpfsPage(props) {
  return (
    <Seo title={'IPFS'} meta={[]}>
      <ScreenIpfs />
      <Footer />
    </Seo>
  );
};

export default hot(module)(IpfsPage);
